import React, { CSSProperties, ReactElement } from 'react';

import { WMIconDownTriangle, WMCircularProgress } from '@walkme/wm-ui';

import styles from './WMTable.module.scss';

export const defaultMinWidth = 1280;
export const defaultRowHeight = 72;

export const getScrollbarSize = (): number => 8;

export const getInlineStyle = (styles = {}, width: number): CSSProperties =>
    ({
        ...styles,
        '--tableWidth': `${width + 2}px`
    } as CSSProperties);

const SortIndicator = ({ className }: { className: string }): ReactElement => (
    <div className={className}>
        <WMIconDownTriangle />
    </div>
);

export const components = { SortIndicator };

export const Empty = ({ loading }: { loading: boolean }): ReactElement => (
    <div className={styles.empty}>{loading ? <WMCircularProgress /> : 'No data'}</div>
);

export const LoadMore = ({ height }: { height: number }): ReactElement => (
    <div className={styles.loadMore} style={{ height }}>
        <WMCircularProgress />
    </div>
);
